import { Directive, OnInit, OnDestroy, ElementRef } from '@angular/core';

/**
 * Como utilizar essa diretiva:
 * 1. defina o max width no target, ou então table-layout: fixed; width: 100%; na <table>
 * 2. Adicione no target um #templateReference
 * 3. Adicione no target o atributo [pTooltip] com o valor igual ao retorno da fn criada no passo anterior
 * 4. Adicione essa diretiva
 * 5. Have fun!
 */
@Directive({
  selector: '[appOverflowTooltip]'
})
export class OverflowTooltipDirective implements OnInit, OnDestroy {

  private observer: MutationObserver;

  constructor(
    private elementRef: ElementRef,
  ) { }

  ngOnInit(): void {

    this.observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        const td = mutation.target.parentElement;
        if (td.scrollWidth > td.offsetWidth) {
          // Caí nesse evento quando ocorre overflow
          td.setAttribute('tooltipText', mutation.target['data']);
          td.style.overflow = 'hidden';
          td.style.textOverflow = 'ellipsis';
        }
      });
    });

    const config = { attributes: true, childList: true, characterData: true, subtree: true };
    this.observer.observe(this.elementRef.nativeElement, config);
  }
  ngOnDestroy(): void {
    this.observer.disconnect();
  }
}
